import React, { useEffect, useMemo, useState } from "react";
import { IconContext } from "react-icons/lib";
import FooterSidebar from "./FooterSidebar";
import { handleSidebarOptions } from "./mainFunctions";
import { SidebarDataOrders } from "./SidebarDataOrders";
import SubMenu from "./SubMenu";

const getCurrentModule = () => {
    const params = window.location.href.split("?token=");
    const modules = params[0].split("?module=");
    return modules[1] || "";
};

const getInitialMenuData = () => {
    const currentModule = getCurrentModule();

    return SidebarDataOrders.map(item => ({
        ...item,
        isClicked: item.id === "ordersMenu",
        className: item.id === "ordersMenu" ? "active" : "",
        subNav: item.subNav?.map(subItem => ({
            ...subItem,
            className: currentModule === "ordersDashboard" && subItem.id === "ordersDashboardAnalytics" ? "active" : ""
        }))
    }));
};

const SidebarOrders = () => {
    const [openMenu, setOpenMenu] = useState(null);
    const iconContextValue = useMemo(() => ({ color: "#fff" }), []);
    const [menuData, setMenuData] = useState(getInitialMenuData);

    useEffect(() => {
        function handleResize() {
            const nav = document.querySelector("#nav-top")?.offsetHeight || 0;
            const contentDiv = document.querySelector("#contentOrders");
            if (contentDiv) {
                contentDiv.style.height = `${window.innerHeight - nav}px`;
            }
        }

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleMenuClick = (id, event, isFromSubMenu) => {
        handleSidebarOptions({ ...event, target: event.currentTarget }, isFromSubMenu);

        setMenuData(prevMenu =>
            prevMenu.map(menu =>
                menu.id === id
                    ? { ...menu, isClicked: true, className: "active" }
                    : { ...menu, isClicked: false, className: "" }
            )
        );
        setOpenMenu(prevMenu => (prevMenu === id ? null : id));
    };

    return (
        <IconContext.Provider value={iconContextValue}>
            <ul className="ulSidebar" id="ulSidebar">
                {menuData.map(item => (
                    <SubMenu
                        item={item}
                        key={item.id}
                        openMenu={openMenu}
                        setOpenMenu={setOpenMenu}
                        handleMenuClick={handleMenuClick}
                    />
                ))}
            </ul>
            <FooterSidebar url="Orders" />
        </IconContext.Provider>
    );
};

export default SidebarOrders;
